// Routes that don't require an authenticated session — shared by anything
// that needs to skip auth-only behavior (session-expiry checks, the study
// heartbeat) on public/marketing/pre-login pages.
export const PUBLIC_ROUTES = [
    "/login",
    "/register",
    "/",
    "/onboarding",
    "/forgot-password",
    "/otp",
    "/reset-password",
    "/reset-otp",
    "/signup",
    "/features",
    "/contact-us",
    "/about",
    "/subjects",
    "/pricing",
    "/testimonials",
    "/group-invite",
    "/group-invite/accept",
    "/group-invite/reject",
    "/webinar",
    "/parent-webinar",
];

// NB: the root route "/" must be matched EXACTLY, not as a prefix — every
// pathname starts with "/", so a naive startsWith("/") marked the whole app
// public. That silently disabled the session-expiry/token-refresh check and
// the study-time heartbeat on every authenticated page (tokens expired with no
// warning and no refresh; study time never accrued). Only "/" needs the exact
// check; the rest legitimately match sub-paths (e.g. "/group-invite/accept").
export const isPublicRoute = (pathname) =>
    PUBLIC_ROUTES.some((route) =>
        route === "/" ? pathname === "/" : pathname.startsWith(route)
    );
